<template>
  <q-banner
    v-if="isEnabled"
    :inline-actions="inlineActions"
    :rounded="rounded"
    :class="bannerClass"
    v-bind="$attrs"
  >
    <slot />
  </q-banner>
  <div v-else variant="custom" v-bind="$attrs">
    <CuiMessage
      type="info"
    >
      <slot />
    </CuiMessage>
  </div>
</template>

<script setup lang="ts">
import { useFeatureFlags } from "@/composables/useFeatureFlags";

const { isEnabled: checkEnabled } = useFeatureFlags();
const isEnabled = checkEnabled("dtpBanner");
type Props = {
  inlineActions?: boolean;
  rounded?: boolean;
  bgColor?: string;
  textColor?: string;
};

const props = withDefaults(defineProps<Props>(), {
  inlineActions: true,
  rounded: false,
  bgColor: "orange",
  textColor: "white"
});

const bannerClass = `bg-${props.bgColor} text-${props.textColor}`;
</script>
